import React, {useState} from 'react';
import {t} from "i18next";
import {Modal} from "../components/Modal";
import {addAward} from "../service/accountApi";

export const AddAwardForm = (props) => {
	const {showAddAwardForm, setShowAddAwardForm, accountDetails, setAccountDetails} = props;

	const [error, setError] = useState({});

	const [isAddAwardButtonDisabled, setIsAddAwardButtonDisabled] = useState(false);

	const [awardDetails, setAwardDetails] = useState({
		awardTitle: '',
		awardDescription: '',
	});

	const handleFormData = (e) => {
		console.log(e.target.name + ': ' + e.target.value);

		setAwardDetails({
			...awardDetails,
			[e.target.name]: e.target.value
		});

		setError({
			...error,
			[e.target.name]: ""
		});
	}

	const validate = () => {
		let err = {};

		if (awardDetails.awardTitle === '') {
			err['awardTitle'] = t("AWARD_FORM.AWARD_TITLE.REQUIRED_ERROR");
		}

		if (awardDetails.awardDescription === '') {
			err['awardDescription'] = t("AWARD_FORM.AWARD_DESCRIPTION.REQUIRED_ERROR");
		}

		return err;
	}

	const handleSubmit = async () => {
		console.log("Inside Handle Submit!");
		setIsAddAwardButtonDisabled(true);
		const err = validate();

		if (Object.keys(err).length > 0) {
			setError(err);
			setIsAddAwardButtonDisabled(false);
			return;
		}

		console.log("Award Details: ", awardDetails);

		const awardData = {
			userAccountId: accountDetails._id,
			awardDetails: awardDetails,
		};
		const addAwardDataResponse = await addAward(awardData);

		console.log('(AddAwardForm) Add Award Data Response: ', addAwardDataResponse);

		if (addAwardDataResponse.success) {
			setAccountDetails(addAwardDataResponse.data);
			setShowAddAwardForm(false);
			setIsAddAwardButtonDisabled(false);
			setTimeout(() => {
				setAwardDetails({
					awardTitle: '',
					awardDescription: '',
				});
			}, 200);
		}
	}

	const handleClose = () => {
		setShowAddAwardForm(false);
		setIsAddAwardButtonDisabled(false);
		setTimeout(() => {
			setError({});
			setAwardDetails({
				awardTitle: '',
				awardDescription: '',
			});
		}, 200);
	}

	return (
		<Modal isOpen={showAddAwardForm}>
			<div className="form-modal-container">
				{/* Header */}
				<div className={"form-modal-header-container"}>
					{/* Header Title | Close Button */}
					<div className={"flex flex-row items-center justify-between"}>
						{/* Form Title */}
						<h2>
							{t("AWARD_FORM.ADD_TITLE")}
						</h2>

						{/* Close Button */}
						<button onClick={handleClose}>
							<img
								className={"w-[75%] h-[75%]"}
								src={"/assets/close-icon.png"}
								alt={"Close"}
								title={"Close"}
							/>
						</button>
					</div>

					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
				</div>

				{/* Form Fields */}
				<div className={"form-modal-body-container"}>
					{/* Award Title */}
					<fieldset>
						<div className="custom-input-container">
							<label htmlFor="awardTitle">
								{t("AWARD_FORM.AWARD_TITLE.LABEL")}
							</label>

							<div className="flex-1 flex flex-col">
								<input
									id="awardTitle"
									className="custom-input"
									name='awardTitle'
									value={awardDetails.awardTitle}
									onChange={handleFormData}
								/>
								{
									error['awardTitle'] &&
									<p className="custom-input-error-message" id="error">
										{error['awardTitle']}
									</p>
								}
							</div>
						</div>
					</fieldset>

					{/* Award Description */}
					<fieldset>
						<div className="custom-input-container">
							<label htmlFor="awardDescription">
								{t("AWARD_FORM.AWARD_DESCRIPTION.LABEL")}
							</label>

							<div className="flex-1 flex flex-col">
                                <textarea
	                                id="awardDescription"
	                                className="custom-input"
	                                name='awardDescription'
	                                value={awardDetails.awardDescription}
	                                onChange={handleFormData}
                                />
								{
									error['awardDescription'] &&
									<p className="custom-input-error-message" id="error">
										{error['awardDescription']}
									</p>
								}
							</div>
						</div>
					</fieldset>
				</div>

				{/* Footer */}
				<div className={"form-modal-footer-container"}>
					{/* Divider */}
					<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

					{/* Submit Button Container */}
					<div className="flex items-center justify-end">
						{/* Submit Button */}
						<button
							disabled={isAddAwardButtonDisabled}
							onClick={handleSubmit}
							className="form-modal-footer-container-submit-button"
						>
							<p>
								{t("AWARD_FORM.ADD_SUBMIT")}
							</p>
							<svg
								viewBox="0 0 6 6"
								fill="none"
								id={"arrow-icon"}
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M3 1L5 3L3 5"
									id={"arrow-icon-tip"}
									stroke="black"
									strokeLinecap="square"
								/>
								<path
									d="M1 3L4 3"
									id={"arrow-icon-line"}
									stroke="black"
									strokeLinecap="square"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
}
